import { createContext } from 'react';
import {
	TLanguageIDs,
	TFileId,
	IStyleSettings,
	ICustomMediaSettingsForUpdate,
	ICustomDocumentSettingsForUpdate,
	IStyleSettingColors,
	TMediaFileType,
	TKeyForNewItemToCarousel,
	TAllergensShowCondition,
} from 'types';

export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'pdfFileSizeExceeded'
	| 'PDFMenuSizeExceeded'
	| 'invalidPdfFileFormat'
	| 'fileUploadError'
	| 'fileDownloadError'
	| 'invalidFileFormat'
	| 'success'
	| 'error';
export interface ISelectedGroup {
	id: string;
	key: string;
}

export interface IStyleState {
	loading: boolean;
	needRefetchData: boolean;
	styleSettings: IStyleSettings[];
	styleSettingColors: IStyleSettingColors;
	mediaSettingsForUpdate: ICustomMediaSettingsForUpdate[];
	documentSettingsForUpdate: ICustomDocumentSettingsForUpdate[];
	selectedGroup: null | ISelectedGroup;
	selectedLanguage: null | TLanguageIDs;
	groupsForLoader: string[];
	typeOfModalWindow: TTypeOfModalWindow;
}

export const styleInitialState: IStyleState = {
	loading: true,
	needRefetchData: false,
	styleSettings: [],
	styleSettingColors: {
		generalColors: [],
		additionalColors: null,
	},
	mediaSettingsForUpdate: [],
	documentSettingsForUpdate: [],
	selectedGroup: null,
	selectedLanguage: null,
	groupsForLoader: [],
	typeOfModalWindow: null,
};

export interface IStyleContext extends IStyleState {
	refetchData(value: boolean): void;
	setStyleSettings(styleItemId: string, value: string, key: string): void;
	setMediaSettingsFromNormalDisplay(
		languageId: null | TLanguageIDs,
		groupId: string,
		translationId: string,
		mediaFileType: TMediaFileType,
		sourceUrl: string,
		fileId: TFileId,
	): void;
	addMediaSettingsToCarousel(
		languageId: null | TLanguageIDs,
		groupId: string,
		translationId: string,
		itemKey: TKeyForNewItemToCarousel,
		mediaFileType: TMediaFileType,
		sourceUrl: string,
		fileId: TFileId,
	): void;
	replacePdfToCarousel({
		translationIdOfItemForDeletion,
		languageId,
		groupId,
		translationId,
		itemKey,
		fileId,
	}: {
		translationIdOfItemForDeletion: string | undefined;
		languageId: TLanguageIDs;
		groupId: string;
		translationId: string;
		itemKey: TKeyForNewItemToCarousel;
		fileId: TFileId;
	}): void;
	deleteMediaSettingsToCarousel(languageId: null | TLanguageIDs, groupId: string, translationId: string): void;
	setGroup(value: ISelectedGroup): void;
	setLanguage(value: TLanguageIDs): void;
	addGroupForLoader(groupId: string): void;
	removeGroupForLoader(groupId: string): void;
	addFileIdForDocumentSettingsForUpdate({
		documentSettingId,
		fileId,
		fileName,
		filePath,
	}: {
		documentSettingId: string;
		fileId: TFileId;
		fileName: string;
		filePath: Nullable<string>;
	}): void;
	setAllergenOptions({
		documentSettingId,
		allergensShowCondition,
	}: {
		documentSettingId: string;
		allergensShowCondition: TAllergensShowCondition;
	}): void;
	toggleShowModal(documentSettingId: string): void;
	submit(): Promise<void>;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const StyleContext = createContext<IStyleContext>({
	refetchData: () => undefined,
	setStyleSettings: () => undefined,
	setMediaSettingsFromNormalDisplay: () => undefined,
	addMediaSettingsToCarousel: () => undefined,
	replacePdfToCarousel: () => undefined,
	deleteMediaSettingsToCarousel: () => undefined,
	setGroup: () => undefined,
	setLanguage: () => undefined,
	addGroupForLoader: () => undefined,
	removeGroupForLoader: () => undefined,
	addFileIdForDocumentSettingsForUpdate: () => undefined,
	setAllergenOptions: () => undefined,
	toggleShowModal: () => undefined,
	submit: async () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...styleInitialState,
});
